import { YStack, type YStackProps } from "tamagui";
import { colors } from "@styles/colors";
import { useSkinV2Page } from "@screen/Home/pages/GasShop/skin";

type ListContainerProps = YStackProps;

/** 白底圓角容器，內部列表項目共用外框 */
export default function ListContainer({ children, ...rest }: ListContainerProps) {
  // V2：圓角 24 + 淺陰影，與 SkinCard 同一款外框（列本身自帶內距，故這裡不加 padding）
  const skinV2 = useSkinV2Page();
  return (
    <YStack
      bg={colors.light}
      br={skinV2 ? 24 : 12}
      ov="hidden"
      style={skinV2 ? { boxShadow: "0 2px 10px -4px rgba(21, 101, 192, 0.10)" } : undefined}
      {...rest}>
      {children}
    </YStack>
  );
}
